import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'
import it from './locales/it.json'
import {
  APP_LANGUAGE_STORAGE_KEY,
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
  resolveInitialAppLanguage
} from './config/languageConstants'

// This module owns the app's one active language, both read and write.
// setAppLanguage() is the single writer - call it, never assign
// i18n.global.locale directly, or a caller could apply an unsupported code or
// forget to persist/sync <html lang>.
const i18n = createI18n({
  legacy: false,
  locale: resolveInitialAppLanguage(),
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: {
    en,
    de,
    it
  },
  globalInjection: true
})

const persist = (lang) => {
  try {
    localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, lang)
  } catch {
    // Non-fatal: the choice still applies for the rest of this session.
  }
}

// Keeps <html lang> in sync so `:lang()` CSS (e.g. the antd filter-dropdown
// "Not Found" pseudo-element, whose text is hardcoded in antd's CSS-in-JS and
// can't be reached via the locale bundle) and assistive tech follow the UI.
const syncHtmlLang = (lang) => {
  try {
    document.documentElement.lang = lang
  } catch {
    // SSR / non-DOM context — nothing to do.
  }
}
syncHtmlLang(i18n.global.locale.value)

export const setAppLanguage = (lang) => {
  if (!SUPPORTED_LANGUAGES.includes(lang)) return
  i18n.global.locale.value = lang
  syncHtmlLang(lang)
  persist(lang)
}

export default i18n
